export default __webpack_public_path__ + "static/media/right-1.df35c58a.jpg";